export const config = {
    /**
     * Default port id for inbound port, used when appending a new node to the existing edge.
     */
    defaultInboundPortId: 'input',
    /**
     * Default port id for outbound port, used when appending a new node to the existing edge.
     */
    defaultOutboundPortId: 'output',
    /**
     * Default port group name for inbound ports.
     */
    inboundPortGroupName: 'in',
    /**
     * Default port group name for outbound ports.
     */
    outboundPortGroupName: 'out',
};
